<template>
  <v-btn
    class="px-2"
    :height="dataHeight"
    :width="dataWidth"
    dark
    color="#0077B5"
    @click="loginWithLinkedIn"
  >
    <div class="full-width d-flex justify-md-space-between">
      <img
        class="v-icon"
        :style="iconStyle"
        :src="require('@/assets/images/icons/socialmedia/linkedin/linkedin-tile.svg')"
      >
      <div class="flex-grow-1 d-flex justify-center align-center">
        <span class="font-weight-bold text-subtitle-1">
          {{ $t('components.AtLinkedInLoginAtom.text') }}
        </span>
      </div>
    </div>
  </v-btn>
</template>

<script>
export default {
  name: 'AtLinkedInLoginAtom',
  props: {
    redirectUri: {
      type: String,
      default: window.location.origin + '/Login/LINKEDIN'
    },
    dataHeight: {
      type: String,
      default: '40'
    },
    dataWidth: {
      type: String,
      default: '300'
    },
    iconStyle: {
      type: Object,
      default: () => ({
        height: '34px',
        width: '34px'
      })
    }
  },
  methods: {
    loginWithLinkedIn () {
      const api = process.env.VUE_APP_LINKEDIN_API_URL
      const url = new URL(this.redirectUri)
      if (this.$route.query.next) {
        url.set('next', this.$route.query.next)
      }
      const query = new URLSearchParams({
        response_type: 'code',
        client_id: process.env.VUE_APP_LINKEDIN_CLIENT_ID,
        redirect_uri: url.toString(),
        scope: 'openid profile email'
      })
      // localStorage.setItem('redirect', window.location.pathname + window.location.search)
      window.location = api + '?' + query
    }
  }
}
</script>
